module.exports = __webpack_public_path__ + "static/media/realtime.a8bbde6e.svg";